var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h50v50h-50z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #38ef7d } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m48.4 48.3q0.3 0.3 0.3 0.7 0 0.4-0.3 0.7-0.3 0.3-0.7 0.3h-45.4q-0.4 0-0.7-0.3-0.3-0.3-0.3-0.7 0-0.4 0.3-0.7 0.3-0.3 0.7-0.3h2.3v-8.8q0-0.5 0.2-1 0.2-0.4 0.5-0.8 0.4-0.4 0.9-0.6 0.5-0.2 1-0.2h4.8q0.5 0 1 0.2 0.5 0.2 0.8 0.6 0.4 0.4 0.6 0.8 0.2 0.5 0.2 1v8.8h5.4v-17q0-0.5 0.2-1 0.2-0.4 0.6-0.8 0.4-0.4 0.9-0.6 0.4-0.2 1-0.2h4.8q0.5 0 1 0.2 0.4 0.2 0.8 0.6 0.4 0.4 0.6 0.8 0.2 0.5 0.2 1v17h5.4v-31.1q0-0.5 0.2-1 0.2-0.4 0.6-0.8 0.4-0.4 0.8-0.6 0.5-0.2 1-0.2h4.8q0.5 0 1 0.2 0.5 0.2 0.9 0.6 0.4 0.4 0.6 0.8 0.2 0.5 0.2 1v31.1h2.1q0.4 0 0.7 0.3zm-35.8-9.1c0-0.3-0.3-0.6-0.6-0.6h-4.8c-0.4 0-0.7 0.3-0.7 0.6v8.8h6.1zm15.5-8.2c0-0.3-0.3-0.6-0.6-0.6h-4.8c-0.4 0-0.7 0.3-0.7 0.6v17.1h6.1zm15.5-14.1c0-0.4-0.3-0.7-0.7-0.7h-4.8c-0.3 0-0.6 0.3-0.6 0.7v31.1h6.1zm2-15.9v5.6q0 0.4-0.3 0.7-0.3 0.3-0.7 0.3-0.4 0-0.7-0.3-0.3-0.3-0.3-0.7v-3.3l-10.3 10.3q-0.2 0.1-0.4 0.2-0.1 0.1-0.3 0.1-0.2 0-0.4-0.1-0.2-0.1-0.3-0.2l-3.7-3.6-16.8 16.8q-0.3 0.3-0.7 0.3-0.4 0-0.7-0.3-0.3-0.3-0.3-0.7 0-0.4 0.3-0.7l17.5-17.5q0.2-0.2 0.4-0.2 0.1-0.1 0.3-0.1 0.2 0 0.4 0.1 0.2 0 0.3 0.2l3.7 3.6 9.6-9.6h-3.6q-0.4 0-0.7-0.3-0.3-0.3-0.3-0.7 0-0.4 0.3-0.7 0.3-0.3 0.7-0.3h5.9q0.2 0 0.4 0.1 0.2 0.1 0.4 0.2 0.1 0.2 0.2 0.3 0.1 0.2 0.1 0.4zm-38.9 29.3q-0.3-0.3-0.3-0.7 0-0.4 0.3-0.7 0.3-0.3 0.7-0.3 0.4 0 0.7 0.3 0.3 0.3 0.3 0.7 0 0.4-0.3 0.7-0.3 0.3-0.7 0.3-0.4 0-0.7-0.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.5c08915458c907a56152522700f0087c.svg";
export { ForwardRef as ReactComponent };